var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "typeCounter--container",
      style: { width: _vm.size + "px", height: _vm.size + "px" }
    },
    [
      _c("svg", { attrs: { height: _vm.size, width: _vm.size } }, [
        _c("circle", {
          staticClass: "typeCounter--circle",
          style: _vm.gradiantValue,
          attrs: {
            cx: _vm.size,
            cy: _vm.size,
            r: _vm.size / 2 - (_vm.strokeSize + 1),
            "stroke-width": _vm.strokeSize,
            "stroke-dasharray": _vm.circumference,
            stroke: _vm.strokeColor
          }
        })
      ]),
      _c("div", { staticClass: "typeCounter--innerCircle" }, [
        _vm._v(
          "\n          " +
            _vm._s(_vm.valid ? _vm.maxValue - _vm.countable : "X") +
            "\n      "
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }